/**
 * @fileoverview gRPC-Web generated client stub for pbs
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var common_pb = require('./common_pb.js')

var user_pb = require('./user_pb.js')
const proto = {};
proto.pbs = require('./course_category_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.CourseCategoryServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.CourseCategoryServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.CourseCategory,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_CourseCategoryService_Create = new grpc.web.MethodDescriptor(
  '/pbs.CourseCategoryService/Create',
  grpc.web.MethodType.UNARY,
  proto.pbs.CourseCategory,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CourseCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.CourseCategory,
 *   !proto.pbs.Empty>}
 */
const methodInfo_CourseCategoryService_Create = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CourseCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.CourseCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.CourseCategoryServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.CourseCategoryService/Create',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_Create,
      callback);
};


/**
 * @param {!proto.pbs.CourseCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.CourseCategoryServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.CourseCategoryService/Create',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.CourseCategory,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_CourseCategoryService_Update = new grpc.web.MethodDescriptor(
  '/pbs.CourseCategoryService/Update',
  grpc.web.MethodType.UNARY,
  proto.pbs.CourseCategory,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CourseCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.CourseCategory,
 *   !proto.pbs.Empty>}
 */
const methodInfo_CourseCategoryService_Update = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CourseCategory} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.CourseCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.CourseCategoryServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.CourseCategoryService/Update',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_Update,
      callback);
};


/**
 * @param {!proto.pbs.CourseCategory} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.CourseCategoryServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.CourseCategoryService/Update',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.CourseCategoryId,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_CourseCategoryService_Delete = new grpc.web.MethodDescriptor(
  '/pbs.CourseCategoryService/Delete',
  grpc.web.MethodType.UNARY,
  proto.pbs.CourseCategoryId,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CourseCategoryId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.CourseCategoryId,
 *   !proto.pbs.Empty>}
 */
const methodInfo_CourseCategoryService_Delete = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CourseCategoryId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.CourseCategoryId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.CourseCategoryServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.CourseCategoryService/Delete',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_Delete,
      callback);
};


/**
 * @param {!proto.pbs.CourseCategoryId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.CourseCategoryServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.CourseCategoryService/Delete',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.CourseCategoryListReq,
 *   !proto.pbs.CourseCategorys>}
 */
const methodDescriptor_CourseCategoryService_List = new grpc.web.MethodDescriptor(
  '/pbs.CourseCategoryService/List',
  grpc.web.MethodType.UNARY,
  proto.pbs.CourseCategoryListReq,
  proto.pbs.CourseCategorys,
  /**
   * @param {!proto.pbs.CourseCategoryListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.CourseCategorys.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.CourseCategoryListReq,
 *   !proto.pbs.CourseCategorys>}
 */
const methodInfo_CourseCategoryService_List = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.CourseCategorys,
  /**
   * @param {!proto.pbs.CourseCategoryListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.CourseCategorys.deserializeBinary
);


/**
 * @param {!proto.pbs.CourseCategoryListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.CourseCategorys)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.CourseCategorys>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.CourseCategoryServiceClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.CourseCategoryService/List',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_List,
      callback);
};


/**
 * @param {!proto.pbs.CourseCategoryListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.CourseCategorys>}
 *     A native promise that resolves to the response
 */
proto.pbs.CourseCategoryServicePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.CourseCategoryService/List',
      request,
      metadata || {},
      methodDescriptor_CourseCategoryService_List);
};


module.exports = proto.pbs;

